import { api } from "@/services/api";
import { Brand } from "@/types";

export class BrandRepository {
  async findAll(): Promise<Brand[]> {
    const response = await api.get("/v1/admin/brands/");

    return response.data;
  }

  async update(
    id: string,
    brandData: {
      name?: string;
      nameAr?: string;
      image?: string;
      isActive?: boolean;
      isLocal?: boolean;
    },
  ): Promise<Brand> {
    const response = await api.patch(`/v1/admin/brands/${id}`, brandData);

    return response.data;
  }

  async add(brandData: {
    name: string;
    nameAr: string;
    image: string;
    id?: string;
    isActive?: boolean;
    isLocal?: boolean;
  }): Promise<Brand> {
    const response = await api.post("/v1/admin/brands", brandData);

    return response.data;
  }
}
